import { ApiMethod } from '@wajeez-web/stores/base';
import {
  Server,
  contentClient,
  publicContentClient,
} from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';
import {
  thunkErrorHandler,
  thunkResponseCheckerSdk,
} from '@wajeez-web/core/utils';
import axios from 'axios';

export const getAllInterests: ApiMethod<
  void,
  Server.InterestOutput[],
  any
> = async (_, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Interests_Client(undefined, contentClient);
    const response = await client.interests_get_V1();
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getUserIntersests: ApiMethod<void, string[] | null, any> = async (
  _,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Interests_Client(undefined, contentClient);
    const response = await client.interests_reader_get_V1();
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const setUserIntersests: ApiMethod<
  Server.SetReaderInterestsInput,
  void,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    dispatch(CommonActions.showLoading({ show: true }));

    const client = new Server.Server_Interests_Client(undefined, contentClient);
    const response = await client.interests_set_post_V1(data);
    if (response.success) {
      dispatch(CommonActions.hideLoading());

      dispatch(
        CommonActions.setAlert({
          for: 'page',
          show: true,
          type: AlertType.SUCCESS,
        })
      );

      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    dispatch(CommonActions.hideLoading());

    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getAllInterestsPublic: ApiMethod<
  void,
  Server.InterestOutput[],
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_Interests_Client(
          undefined,
          publicContentClient
        );

        const response = await client.interests_getAllInterests_get_V1('1');

        for (const item of response?.data ?? []) {
          if (item.iconUrl) preload_image(item.iconUrl);
        }

        return response;
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

function preload_image(im_url: string) {
  axios.get(im_url);
}
